import axios from "axios";

// The digest is one mail with two sections, so its unsubscribe page offers a choice rather
// than a single button. A request changes only the channels it names.
export type DigestChannels = {
  weeklyDigest?: boolean;
  weeklyDigestPublic?: boolean;
};

export class ServiceWeeklyDigestController {
  async fetchChannels({ p, s }: { p: string, s: string }): Promise<DigestChannels> {
    const response = await axios.get(`/api/organizations/superadmin/weekly-digest/unsubscribe/status/${p}/${s}`);
    return response.data.channels ?? {};
  }
  /** Answers with the state that now applies, so the page cannot claim more than it did. */
  async updateChannels({ p, s, channels }: { p: string, s: string, channels: DigestChannels }): Promise<DigestChannels> {
    const response = await axios.post(`/api/organizations/superadmin/weekly-digest/unsubscribe/${p}/${s}`, { channels });
    return response.data.channels ?? {};
  }
  async recalculate(): Promise<void> {
    await axios.delete('/api/weekly-digest/current');
    await axios.post('/api/weekly-digest');
  }
  async sendToUser(userId: string): Promise<void> {
    await axios.post(`/api/weekly-digest/send/${userId}`);
  }
}

export const ServiceWeeklyDigest = new ServiceWeeklyDigestController();
